let detail_data = [
    {
        type: `여성 라이프스타일`,
        name: '모터코어 컬러블럭 패딩자켓',
        price: '239,000원',
        imgUrl: '/img/motorcore9.jpg'
    },
    {
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 컬러블럭 우븐팬츠',
        price: '159,000원',
        imgUrl: '/img/motorcore3.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '모터코어 절개포인트 후드 바람막이',
        price: '199,000원',
        imgUrl: '/img/motorcore4.jpg'
    },
    {
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 절개포인트 우븐팬츠',
        price: '159,000원',
        imgUrl: '/img/motorcore5.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '모터코어 컬러블럭 바람막이',
        price: '199,000원',
        imgUrl: '/img/motorcore2.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '모터코어 와펜포인트 바람막이',
        price: '189,000원',
        imgUrl: '/img/motorcore12.jpg'
    },
    {
        type: '남녀공용 라이프스타일 지속가능소재',
        name: '립스탑 블럭다운 패딩자켓',
        price: '299,000원',
        imgUrl: '/img/padding5.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '모터코어 절개포인트 후드 바람막이',
        price: '199,000원',
        imgUrl: '/img/motorcore10.jpg'
    },
    {
        type: '여성 컴포트핏 라이프스타일',
        name: '면혼방스트레치 모크넥 긴팔티',
        price: '59,000원',
        imgUrl: '/img/neckt.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '숄카라 보아 플리스',
        price: '129,000원',
        imgUrl: '/img/kara.jpg'
    },
    {
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 절개포인트 우븐팬츠',
        price: '159,000원',
        imgUrl: '/img/motorcore11.jpg'
    },
    {
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 스트레치 카라 맨투맨',
        price: '89,000원',
        imgUrl: '/img/motorcore7.jpg'
    }
]


export default detail_data;